import { axios } from '@/utils/request'
import qs from 'qs'

let moduleName = 'inductionInvitation'

export function selectAll(parameter) {
  console.log('params:', parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export function selectALlInduction(parameter) {
  console.log('params:', parameter)
  return axios({
    url: `/ws/${moduleName}/selectALlInduction`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectOne(parameter) {
  console.log('id:', parameter)
  return axios({
    url: `/ws/${moduleName}/${parameter}`,
    method: 'get'
  })
}


export function getByNumber(parameter) {
  console.log('id:', parameter)
  return axios({
    url: `/out/${moduleName}/getByNumber/${parameter}`,
    method: 'get'
  })
}



export function getInductionDatadic(pathMap){
  return axios({
    url: `/out/${moduleName}/getInductionDatadic`,
    method: 'get',
    params:pathMap,
  })
}

export function selectDetail(parameter) {
  console.log('id:', parameter)
  return axios({
    url: `/ws/${moduleName}/selectDetail/${parameter}`,
    method: 'get'
  })
}

export function selectTips(parameter) {
  console.log('id:', parameter)
  return axios({
    url: `/ws/${moduleName}/selectTips/${parameter}`,
    method: 'get'
  })
}


export function insert(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data: parameter
  })
}


export function inductionHandling(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}/inductionHandling`,
    method: 'post',
    data: parameter
  })
}

export function insertAll(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}/insertAll`,
    method: 'post',
    data: parameter
  })
}

export function editEmpAll(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}/editEmpAll`,
    method: 'post',
    data: parameter
  })
}

export function insertOutAll(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/out/${moduleName}/insertAll`,
    method: 'post',
    data: parameter
  })
}

export function updateAll(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}/updateAll`,
    method: 'post',
    data: parameter
  })
}

export function update(id, parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data: parameter
  })
}

export function cancelInduction(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}/cancelInduction`,
    method: 'put',
    data: parameter
  })
}


export function deleteObj(ids) {
  console.log('ids', ids)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'delete',
    params: ids,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export function exportMansionPPT(id){
  return axios({
    url: `/ws/${moduleName}/exportFile/${id}`,
    method: 'get',
    responseType: 'blob',
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}



export default {
  save: insert,
  saveAll:insertAll,
  InsertOutAll:insertOutAll,
  updateAll,
  cancelInduction,
  update,
  selectDetail,
  getByNumber,
  selectTips,
  editEmpAll,
  inductionHandling,
  delete: deleteObj,
  queryById: selectOne,
  selectAll: selectAll,
  selectALlInduction:selectALlInduction,
  getInductionDatadic,
  exportMansionPPT
}